<template>
  <el-tooltip
    :manual="true"
    effect="light"
    popper-class="light-popper bottom-start"
    placement="bottom-start"
    :visible="visible"
    :arrow-offset="1000"
    v-bind="$attrs"
  >
    <template #content>
      <div v-for="(rule, index) in rules" :key="index" class="list">
        <svg-icon
          :color="rule.status === 'valid' ? '#2BBF57' : '#db2838'"
          :icon-class="rule.status === 'valid' ? 'pass2' : 'info'"
          class-name="f-s-16"
        />
        {{ rule.message }}
      </div>
    </template>
    <slot></slot>
  </el-tooltip>
</template>

<script setup>
  import { onMounted, reactive, watch } from "vue";

  const props = defineProps({
    value: {
      type: String,
      required: true
    },
    visible: {
      type: String,
      required: true
    },
    rules: {
      type: Array,
      default: () => []
    }
  });
  const rules = reactive(props.rules);

  const validateRule = async (rule) => {
    try {
      if (rule.validator && typeof rule.validator === "function") {
        const result = await rule.validator(props.value); // 异步校验
        rule.status = result ? "valid" : "invalid";
      } else {
        const result = rule.validator(props.value); // 同步校验
        rule.status = result ? "valid" : "invalid";
      }
    } catch {
      rule.status = "invalid"; // 异常处理
    }
  };

  const validateAllRules = async () => {
    const promises = rules.map((rule) => validateRule(rule));
    await Promise.all(promises);
  };

  watch(() => props.value, validateAllRules);

  onMounted(() => {
    validateAllRules();
  });
  defineExpose({
    validateAllRules
  });
</script>

<style lang="scss" scoped>
  .list {
    display: flex;
    align-items: center;
    font-size: 12px;
    color: $neutral-neutral-80;
    line-height: 16px;
    gap: 4px;
  }
  .list + .list {
    margin-top: 16px;
  }
</style>
